import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import {
  IFeaturedShiftsCampaign,
  IGetFeaturedShiftsCampaignsParams,
  IPutFeaturedShiftsCampaignParams,
  IPostFeaturedShiftsCampaignParams,
} from 'models/FeaturedShiftsCampaign'

export class FeaturedShiftsCampaignsApi {
  constructor(private axios: AxiosService) {}

  getFeaturedShiftsCampaigns = async (
    params?: IGetFeaturedShiftsCampaignsParams,
  ) => {
    const response = await this.axios.get<IPayload<IFeaturedShiftsCampaign[]>>(
      Endpoints.getFeaturedShiftsCampaigns,
      params,
    )
    return response
  }

  getFeaturedShiftsCampaign = async (
    id: number,
    params?: IGetFeaturedShiftsCampaignsParams,
  ) => {
    const response = await this.axios.get<IPayload<IFeaturedShiftsCampaign>>(
      Endpoints.getFeaturedShiftsCampaign(id),
      params,
    )
    return response
  }

  postFeaturedShiftsCampaign = async (
    params: IPostFeaturedShiftsCampaignParams,
  ) => {
    const response = await this.axios.post<IPayload<IFeaturedShiftsCampaign>>(
      Endpoints.postFeaturedShiftsCampaign,
      params,
    )
    return response
  }

  putFeaturedShiftsCampaign = async (
    id: number,
    params?: IPutFeaturedShiftsCampaignParams,
  ) => {
    const response = await this.axios.put<IPayload<IFeaturedShiftsCampaign>>(
      Endpoints.putFeaturedShiftsCampaign(id),
      params,
    )
    return response
  }

  deleteFeaturedShiftsCampaign = async (id: number) => {
    const response = await this.axios.delete<{}>(
      Endpoints.deleteFeaturedShiftsCampaign(id),
    )
    return response
  }
}
